import { z } from 'zod'

import { HOTKEY_EVENT_NAMES, KEYDOWN_KEYS } from './constants'

const modifier = z
  .enum(['Meta', 'Control', 'Shift', 'Alt', 'default'] as const)
  .optional()
  .default('default')
  .meta({ id: 'modifier' })
const modifiers = z
  .array(modifier)
  .optional()
  .default(['default'])
  .meta({ id: 'modifiers' })

export type HotKeyModifiers = z.infer<typeof modifiers>

const hotKeys = z
  .record(
    z.enum(KEYDOWN_KEYS),
    z.object({
      modifiers: modifiers.optional(),
      event: z.enum(HOTKEY_EVENT_NAMES),
    }),
  )
  .meta({ id: 'hot-keys' })
export type HotKeyConfig = z.infer<typeof hotKeys>

export const hotKeyConfigSchema = z
  .object({
    modifiers,
    hotKeys: hotKeys.optional(),
  })
  .optional()
  .meta({ id: 'hot-key-config' })
